import { normalizeBillRow, normalizeServiceJob, normalizeString } from './serviceNormalization';

const getBillDate = (bill) => bill?.invoiceDate || bill?.date || null;
const getBillNo = (bill) => bill?.number || bill?.invoiceNumber || bill?.billNumber || '';
const getPartyId = (bill) => bill?.partyId || bill?.party || bill?.partyCode || '';
const getPartyName = (bill, partiesById = {}) => {
  const partyId = getPartyId(bill);
  return (
    partiesById?.[partyId]?.firmName ||
    partiesById?.[partyId]?.name ||
    bill?.partyName ||
    bill?.customerName ||
    ''
  );
};

const inferServiceName = (service, rowTags = []) => {
  if (service?.serviceName) return service.serviceName;
  const firstTag = Array.isArray(rowTags) ? rowTags[0] : '';
  return firstTag || '';
};

export const extractServiceJobsFromBills = (bills = [], options = {}) => {
  const partiesById = options.partiesById || {};
  const itemsById = options.itemsById || {};
  const includeTagBackfill = options.includeTagBackfill === true;
  const jobs = [];

  bills.forEach((bill) => {
    const billId = normalizeString(bill?.id);
    const billNo = normalizeString(getBillNo(bill));
    const billDate = getBillDate(bill);
    const partyId = normalizeString(getPartyId(bill));
    const partyName = normalizeString(getPartyName(bill, partiesById));
    const rows = Array.isArray(bill?.rows) ? bill.rows : [];

    rows.forEach((rawRow, rowIndex) => {
      const row = normalizeBillRow(rawRow);
      const services = Array.isArray(row.services) ? row.services : [];
      const resolvedItemId = normalizeString(row?.item);
      const resolvedItemName = normalizeString(
        row?.itemName ||
        row?.description ||
        itemsById?.[resolvedItemId]?.itemName ||
        itemsById?.[resolvedItemId]?.name ||
        resolvedItemId
      );
      const rowMeasureFields = {
        qtyExpr: rawRow?.qtyExpr,
        qtyDisplay: rawRow?.qtyDisplay,
        qty: rawRow?.qty,
        unit: rawRow?.unit,
        quantityMeasurement: rawRow?.quantityMeasurement,
        nos: rawRow?.nos,
        length: rawRow?.length,
        height: rawRow?.height,
      };

      if (services.length > 0) {
        services.forEach((service) => {
          const serviceName = inferServiceName(service, row.tags);
          if (!serviceName) return;
          jobs.push(
            normalizeServiceJob({
            docType: bill?.docType || 'invoice',
              billId,
              billNo,
              billDate,
              partyId,
              partyName,
              itemId: resolvedItemId,
              itemName: resolvedItemName,
              rowIndex,
              serviceId: service.id,
              serviceName,
              vendorId: service.vendorId,
              vendorName: service.vendorName,
              internalCost: service.internalCost,
              customerCharge: service.customerCharge,
              showOnInvoice: service.showOnInvoice,
              status: service.status,
              createdAt: service.createdAt,
              ...rowMeasureFields,
            })
          );
        });
      } else if (includeTagBackfill && Array.isArray(row.tags) && row.tags.length > 0) {
        row.tags.forEach((tagValue, tagIndex) => {
          const serviceName = normalizeString(tagValue).toLowerCase();
          if (!serviceName) return;
          jobs.push(
            normalizeServiceJob({
              docType: bill?.docType || 'invoice',
              billId,
              billNo,
              billDate,
              partyId,
              partyName,
              itemId: resolvedItemId,
              itemName: resolvedItemName,
              rowIndex,
              serviceId: `legacy_${billId}_${rowIndex}_${tagIndex}`,
              serviceName,
              vendorId: '',
              vendorName: '',
              internalCost: 0,
              customerCharge: 0,
              showOnInvoice: false,
              status: 'pending',
              createdAt: null,
              ...rowMeasureFields,
            })
          );
        });
      }
    });
  });

  return jobs;
};

export const indexPartiesById = (parties = []) => {
  return parties.reduce((acc, party) => {
    if (!party?.id) return acc;
    acc[party.id] = party;
    return acc;
  }, {});
};
